// ANI · motion leaf — gallery parallax + caption reveal

import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { usePrefersReducedMotion } from "@/lib/animation/prefers-reduced-motion";
import { DUR } from "@/features/landing/motion/tokens";

export function useAniMotion(scope: React.RefObject<HTMLElement | null>) {
  const reduced = usePrefersReducedMotion();

  useGSAP(
    () => {
      const feature = scope.current?.querySelector<HTMLElement>(".ani__feature img");
      const caption = scope.current?.querySelector<HTMLElement>(".ani__caption");
      const marginalia = scope.current?.querySelectorAll<HTMLElement>(".ani__marginalia-item");
      const title = scope.current?.querySelector<HTMLElement>(".ani__title");

      if (reduced) {
        gsap.set([title, caption, ...(marginalia ?? [])], { clearProps: "all" });
        return;
      }

      // Image parallax
      if (feature) {
        gsap.to(feature, {
          yPercent: -8,
          ease: "none",
          scrollTrigger: { trigger: scope.current, start: "top bottom", end: "bottom top", scrub: 1.4 },
        });
      }

      if (title) {
        gsap.fromTo(title, { autoAlpha: 0, y: 24 }, {
          autoAlpha: 1, y: 0, duration: DUR.slow, ease: "power3.out",
          scrollTrigger: { trigger: title, start: "top 85%", toggleActions: "play none none reset" },
        });
      }
      if (caption) {
        gsap.fromTo(caption, { autoAlpha: 0, y: 16 }, {
          autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power2.out",
          scrollTrigger: { trigger: caption, start: "top 88%", toggleActions: "play none none reset" },
        });
      }
      if (marginalia) {
        marginalia.forEach((item, i) => {
          gsap.fromTo(item, { autoAlpha: 0, x: 12 }, {
            autoAlpha: 1, x: 0, duration: DUR.normal, ease: "power2.out",
            delay: i * 0.06,
            scrollTrigger: { trigger: item, start: "top 92%", toggleActions: "play none none reset" },
          });
        });
      }
    },
    { scope, dependencies: [reduced] }
  );
}